module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-animation"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "spinner"
  }, [_c('div', {
    staticClass: "double-bounce1"
  }), _c('div', {
    staticClass: "double-bounce2"
  })]) : _c('div', {
    staticClass: "slot"
  }, [_vm._t("default")], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6baaa8f7!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/LoadingAnimation.vue
// module id = 2570
// module chunks = 1